<template>
  <span v-tooltip="utcMoment.format()">{{ localDateStr }}</span>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'LocalDateTime',
  props: {
    datetime: {
      type: String,
      required: true,
    },
    timezone: {
      type: String,
      required: false,
      default: null,
    },
    format: {
      type: String,
      required: false,
      default: 'lll',
    },
    showTz: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    localTz() {
      return this.timezone || moment.tz.guess();
    },
    utcMoment() {
      return moment.utc(this.datetime);
    },
    localDateStr() {
      return this.utcMoment.tz(this.localTz).format(this.fullFormat);
    },
    fullFormat() {
      return this.showTz ? `${this.format} zz` : this.format;
    },
  },
};
</script>
